import SocketClient from '@/socket/index'
import CreditSocketClient from '@/socket/credit/index'
import { isElectron } from '@/utils/electron/electronUtils'

/**
 * 추후 인스톨된 패키지 제거 후 메인 피쳐로 바꿔서 다시 인스톨 해야함
 * 로컬 서버 url도 같이 수정 필요
 * */
export const socket = isElectron() ? null : new SocketClient(process.env.REACT_APP_SOCKET_SERVER || window.ENV?.REACT_APP_SOCKET_SERVER || 'http://localhost:5050')
export const creditSocket = isElectron() ? null : new CreditSocketClient(process.env.REACT_APP_CREDIT_API_HOST || 'http://localhost:8084')
